export default "__VITE_ASSET__Dq4TrnAo__"